"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ChevronDownCircleSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var ChevronDownCircleSVG = function ChevronDownCircleSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M16 30A14 14 0 102 16c0 10.4 9 14 14 14zM9.3 13.3a1 1 0 011.4 0l5.3 5.3 5.3-5.3a1 1 0 011.4 0 1 1 0 010 1.4l-6 6a1 1 0 01-1.4 0l-6-6a1 1 0 010-1.4z"
  }));
};
exports.ChevronDownCircleSVG = ChevronDownCircleSVG;
ChevronDownCircleSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ChevronDownCircleSVG);
exports.default = _default;